<template>
<router-view />
</template>

<script>
export default {
  name: 'DataManagementDataStatistical',
  routeInfo: {
    label: '数据统计',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/01Data-Statistical/index.vue